export function getIconAndNameFromExtension(fileExtension: string) {

    const extensionInfoMap = new Map<string, [string, string]>([
        ['png', ['png.svg', 'PNG Image (.png)']],
        ['jpg', ['jpg.svg', 'JPEG Image (.jpg)']],
        ['jpeg', ['jpeg.svg', 'JPEG Image (.jpeg)']],
        ['gif', ['gif.svg', 'GIF Image (.gif)']],
        ['bmp', ['bmp.svg', 'BMP Image (.bmp)']],
        ['doc', ['doc.svg', 'Microsoft Word Document (.doc)']],
        ['docx', ['docx.svg', 'Microsoft Word Document (.docx)']],
        ['pdf', ['pdf.svg', 'PDF Document (.pdf)']],
        ['rar', ['rar.svg', 'RAR Archive (.rar)']],
        ['tiff', ['tiff.svg', 'Tag Image File Format (.tiff)']],
        ['zip', ['zip.svg', 'ZIP Archive (.zip)']],
        ['xls', ['xls.svg', 'Microsoft Excel Spreadsheet (.xls)']],
        ['xlsx', ['xlsx.svg', 'Microsoft Excel Spreadsheet (.xlsx)']],
        ['csv', ['csv.png', 'Comma Separated Values (.csv)']],
    ]);

    return extensionInfoMap.get(fileExtension);
}
